let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("WOIba")).then(() => parcelRequire('k0doW'));